import { createFileRoute } from '@tanstack/react-router';
import Settings from '../../components/client/Settings';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/settings')({
  component: ClientSettingsRoute,
});

function ClientSettingsRoute() {
  const { user, isManager } = useAuth();
  const content = <Settings user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
